import React, { useEffect, useState } from "react";
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    IconButton,
    Typography,
    Drawer,
    useMediaQuery,
    useTheme,
} from "@mui/material";

import {
    Menu as MenuIcon,
    Dashboard,
    Store,
    Inventory2,
    ShoppingCart,
    ExpandLess,
    ExpandMore,
    AddBox,
    ListAlt,
    Reviews,
    Settings,
    Close,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../Redux/store";
import { setActiveMenue, setOpenSideMenue } from "../../../Redux/Reducers/globalSlice";
import { useNavigate } from "react-router-dom";

function VenderMenue() {
    const theme = useTheme();

    // Responsive Breakpoints
    const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
    const isMdUp = useMediaQuery(theme.breakpoints.down("xl"));

    const [openSidebar, setOpenSidebar] = useState(isMdUp ? false : true);
    const { openSideMenue, activeMenue, venderDetails } = useSelector((state: RootState) => state.global)
    const dispatch = useDispatch()
    const [mobileOpen, setMobileOpen] = useState(openSideMenue);
    const navigate = useNavigate()

    const [openMenu, setOpenMenu] = useState<any>({});
    const [selectedmenue, setselctedMenue] = useState(activeMenue);

    // useEffect(() => {
    //     if (isMdUp) {
    //         setOpenSidebar(true); 
    //     }
    // }, [isMdUp]);


    useEffect(() => {
        setselctedMenue(activeMenue)
    }, [activeMenue])

    useEffect(() => {
        setMobileOpen(openSideMenue)
    }, [openSideMenue])

    // Sidebar Menu Array
    const menuList = [
        {
            title: "Dashboard",
            icon: <Dashboard />,
        },
        {
            title: "Shop Profile",
            icon: <Store />,
        },
        {
            title: "Products",
            icon: <Inventory2 />,
            // submenu: [
            //     {
            //         title: "All Products",
            //         icon: <ListAlt />,
            //     },
            //     {
            //         title: "Add Product",
            //         icon: <AddBox />,
            //     },
            // ],
        },
        {
            title: "Orders",
            icon: <ShoppingCart />,
        },
        {
            title: "Reviews",
            icon: <Reviews />,
        },
        {
            title: "Settings",
            icon: <Settings />,
        },
    ];

    const handleToggle = (title: string) => {
        setOpenMenu((prev: any) => ({
            ...prev,
            [title]: !prev[title],
        }));
    };

    // Sidebar Content
    const SidebarContent = () => (
        <Box
            className='bg-main h-100  overflow-hidden side-border'
            sx={{
                width: isPhone ? 270 : openSidebar ? 230 : 80,
                transition: "0.3s",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    maxHeight: '65px',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: openSidebar ? "space-between" : "center",
                    p: 2,
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                }}
            >
                {(openSidebar || isPhone) && (
                    <Box className="d-flex align-items-center gap-2">
                        <Box
                            component={"img"}
                            src={venderDetails?.logo_url}
                            className="rounded-circle border"
                            height={40}
                            width={40}
                        />

                        {/* <Typography
                            className='fs-16 text-white fw-bold'>
                            {venderDetails?.display_name} {venderDetails?.display_name}
                        </Typography> */}
                    </Box>
                )}

                {/* Desktop Toggle */}
                {!isPhone && (
                    <IconButton onClick={() => setOpenSidebar(!openSidebar)}>
                        <MenuIcon sx={{ color: "white" }} />
                    </IconButton>
                )}

                {/* Mobile Close */}
                {isPhone && (
                    <IconButton onClick={() => dispatch(setOpenSideMenue(false))}>
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                )}
            </Box>

            {/* Menu */}
            <List sx={{ p: 1 }}>
                {menuList.map((item: any, index: number) => (
                    <Box key={index} sx={{ mb: 1 }}>
                        {/* Main Menu */}
                        <ListItemButton
                            onClick={() => {
                                if (item.submenu) {
                                    handleToggle(item.title);
                                } else {
                                    dispatch(setActiveMenue(item.title))
                                    navigate(`/vender/${item.title}`)

                                    if (isPhone) {
                                        dispatch(setOpenSideMenue(false));
                                    }
                                }
                            }}
                            sx={{
                                borderRadius: "12px",
                                mb: 0.5,
                                background:
                                    selectedmenue === item.title
                                        ? "var(--secondary-light-color)"
                                        : "transparent",

                                "&:hover": {
                                    background: "var(--secondary-light-color)",
                                },
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    color: selectedmenue == item.title ? "var(--secondary-color)" : "white",
                                    minWidth: 40,
                                }}
                            >
                                {item.icon}
                            </ListItemIcon>

                            {(openSidebar || isPhone) && (
                                <>
                                    <ListItemText
                                        className="fs-14"
                                        sx={{
                                            color: selectedmenue == item.title ? "var(--secondary-color)" : "white",
                                        }}
                                        primary={item.title}
                                    />

                                    {item.submenu &&
                                        (openMenu[item.title] ? (
                                            <ExpandLess sx={{ color: "white" }} />
                                        ) : (
                                            <ExpandMore sx={{ color: "white" }} />
                                        ))}
                                </>
                            )}
                        </ListItemButton>

                        {/* Submenu */}
                        {item.submenu && (
                            <Collapse
                                in={openMenu[item.title] && (openSidebar || isPhone)}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    {item.submenu.map(
                                        (subItem: any, subIndex: number) => (
                                            <ListItemButton
                                                className="mx-1 ms-5 border-10 mb-2"
                                                key={subIndex}
                                                onClick={() => {
                                                    dispatch(setActiveMenue(subItem.title))

                                                    if (isPhone) {
                                                        dispatch(setOpenSideMenue(false))
                                                    }
                                                }}
                                                sx={{
                                                    background:
                                                        selectedmenue === subItem.title
                                                            ? "var(--secondary-light-color)"
                                                            : "transparent",

                                                    "&:hover": {
                                                        background: "var(--secondary-light-color)",
                                                    },
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        color: selectedmenue == subItem.title ? "var(--secondary-color)" : "white",
                                                        minWidth: 35,
                                                    }}
                                                >
                                                    {subItem.icon}
                                                </ListItemIcon>

                                                <ListItemText
                                                    className="fs-14"
                                                    sx={{
                                                        color: selectedmenue == subItem.title ? "var(--secondary-color)" : "white",
                                                    }}
                                                    primary={subItem.title}
                                                />
                                            </ListItemButton>
                                        )
                                    )}
                                </List>
                            </Collapse>
                        )}
                    </Box>
                ))}
            </List>
        </Box>
    );

    return (
        <>
            {/* Mobile Topbar */}
            {/* {isPhone && (
        <Box
          sx={{
            height: 65,
            background: "#111827",
            display: "flex",
            alignItems: "center",
            px: 2,
            justifyContent: "space-between",
          }}
        >
          <IconButton onClick={() => setMobileOpen(true)}>
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      )} */}

            {/* Desktop Sidebar */}
            {!isPhone && (
                <Box
                    sx={{
                        position: "sticky",
                        top: 0,
                        height: "100vh",
                    }}
                >
                    <SidebarContent />
                </Box>
            )}

            {/* Mobile Drawer */}
            {isPhone && (
                <Drawer
                    anchor="left"
                    open={mobileOpen}
                    onClose={() => dispatch(setOpenSideMenue(false))}
                >
                    <SidebarContent />
                </Drawer>
            )}
        </>
    );
}

export default VenderMenue;